import actions from "./actions";

const initialState = {
  createMdnSwapLoading: false,
  createMdnSwapMessage: null,
  createMdnSwapError: null,

  //get mdn swap
  getMdnSwapLoading: false,
  getMdnSwapData: null,
  getMdnSwapError: null,

  bulkMDNSwapResultByBatchID: [],
  bulkMDNSwapResultByBatchIDLoading: false,
  bulkMDNSwapResultByBatchIDError: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_MDN_SWAP_REQUEST:
      return {
        ...state,
        createMdnSwapLoading: true,
        createMdnSwapMessage: null,
        createMdnSwapError: null,
      };

    case actions.CREATE_MDN_SWAP_REQUEST_SUCCESSFUL:
      return {
        ...state,
        createMdnSwapLoading: false,
        createMdnSwapMessage: action.message,
        createMdnSwapError: null,
      };

    case actions.CREATE_MDN_SWAP_REQUEST_FAILED:
      return {
        ...state,
        createMdnSwapLoading: false,
        createMdnSwapMessage: null,
        createMdnSwapError: action.error,
      };
    case actions.RESET_MDN_SWAP_MESSAGE:
      return {
        ...state,
        createMdnSwapMessage: null,
        createMdnSwapError: null,
      };

    case actions.GET_MDN_SWAP_REQUEST:
      return {
        ...state,
        getMdnSwapLoading: true,
        getMdnSwapData: null,
        getMdnSwapError: null,
      };
    case actions.GET_MDN_SWAP_REQUEST_SUCCESSFUL:
      return {
        ...state,
        getMdnSwapLoading: false,
        getMdnSwapData: action.payload.data,
        getMdnSwapError: null,
      };
    case actions.GET_MDN_SWAP_REQUEST_FAILED:
      return {
        ...state,
        getMdnSwapLoading: false,
        getMdnSwapData: null,
        getMdnSwapError: action.error,
      };

    case actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST:
      return {
        ...state,
        bulkMDNSwapResultByBatchIDLoading: true,
        bulkMDNSwapResultByBatchID: null,
        bulkMDNSwapResultByBatchIDError: action.error,
      };
    case actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_SUCCESSFUL:
      return {
        ...state,
        bulkMDNSwapResultByBatchIDLoading: false,
        bulkMDNSwapResultByBatchID: action.payload.result,
        bulkMDNSwapResultByBatchIDError: null,
      };
    case actions.GET_MDN_SWAP_BATCHTRANSACTIONBYID_REQUEST_FAILED:
      return {
        ...state,
        bulkMDNSwapResultByBatchIDLoading: false,
        bulkMDNSwapResultByBatchID: null,
        bulkMDNSwapResultByBatchIDError: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
